module.exports = __webpack_public_path__ + "img/instagram.da3e4fda.png";